var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from 'events';
import { AppJsApi } from '../common/config';
import { AppDownloadStatus } from '../../../common/constants';
import { createDeeplink } from '../common/scheme';
import loadJs from '../common/loadjs';
import { errorLogger } from '../../debug';
import { AppPackage } from '../common/appInfo';
/**
 * 快手下载器实现
 * 相关文档：http://kbandroid.pages.oa.com/html/jsapi/index.html
 */
var KBDownloader = /** @class */ (function (_super) {
    __extends(KBDownloader, _super);
    function KBDownloader(opt) {
        var _this = _super.call(this) || this;
        _this.name = 'KBDownloader';
        _this.opt = __assign({}, opt);
        var _a = _this.opt, url = _a.url, appId = _a.appId, channelId = _a.channelId, filename = _a.filename, packagename = _a.packagename, _b = _a.iconUrl, iconUrl = _b === void 0 ? '' : _b, active = _a.active;
        _this.downloadInfo = {
            type: 1,
            url: url,
            appId: Number(appId),
            appName: filename,
            packageName: packagename,
            // versionCode: 47400,
            appChannelId: channelId,
            iconUrl: iconUrl,
            // adStr: "B38AEQABFgAmBDcxOTMwAUJZS2i/AQDjBhMxMjA2MDMyNTAxOTI2NDI0NTc2EQEQIAE2AEYbDBD/JgA8SQABCgAHHCwyAAMOc0ABXGYAC1kMUAFmCDEwMDI4MTQ5dAAAAACMkQGQpD+TMzO0AAAAAMzQBOID6mTX+Q8M9hALMTAwLjY1LjE3LjbyEVlLaL/yEgACb6n2E0AdWOvQR79eKaWLt6AfeXoERbEM4sb8mUe1nGnHxfU33Awnq2ESjBUToQnaKUofAC/XXC4FAA3TJtyuyCxkPuny/BT8FfYWAPwX9hgA/Bn2GgJOQfwb9hwCTkH2HQD4Hgz2HwA=",
            applink: active,
            autoOpen: 1,
            oplist: "1;2" // 下载任务操作类型, 中间用";"分割, 0: 什么都不做, 1: 创建任务自动下载, 2: 下载完成自动安装. "1;2"表示创建下载任务之后自动下载并且下载完后自动唤起安装界面
        };
        return _this;
    }
    KBDownloader.prototype.ready = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, loadJs([AppJsApi.KB])];
                    case 1:
                        _b.sent();
                        window.registerCallback = function (info) {
                            console.log('registerCallback', info);
                        };
                        window.stateCallback = function (arrayJson) {
                            _this.downloadStatusInfo = arrayJson || {};
                        };
                        if ((_a = window === null || window === void 0 ? void 0 : window.TencentReading) === null || _a === void 0 ? void 0 : _a.invokeMethod) {
                            window.TencentReading.invokeMethod('registerDownloadCallBackListener', 'stateCallback', 'registerCallback');
                        }
                        else {
                            errorLogger('异常:', 'invokeMethod', '无此方法');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    KBDownloader.prototype.start = function () {
        var _a;
        if ((_a = window === null || window === void 0 ? void 0 : window.TencentReading) === null || _a === void 0 ? void 0 : _a.invokeMethod) {
            window.TencentReading.invokeMethod('startDownload', JSON.stringify(this.downloadInfo));
        }
    };
    KBDownloader.prototype.pause = function () {
        var _a;
        if ((_a = window === null || window === void 0 ? void 0 : window.TencentReading) === null || _a === void 0 ? void 0 : _a.invokeMethod) {
            window.TencentReading.invokeMethod('pauseDownload', JSON.stringify(this.downloadInfo));
        }
    };
    KBDownloader.prototype.resume = function () {
        this.start();
    };
    KBDownloader.prototype.install = function () {
        this.start();
    };
    KBDownloader.prototype.open = function () {
        var _a;
        var _b = this.opt, packagename = _b.packagename, active = _b.active;
        if (packagename === AppPackage.KB) {
            return location.href = active;
        }
        if ((_a = window === null || window === void 0 ? void 0 : window.TencentReading) === null || _a === void 0 ? void 0 : _a.openApp) {
            return window.TencentReading.openApp(active, packagename);
        }
        if (active) {
            return location.href = active;
        }
        return location.href = createDeeplink(packagename);
    };
    KBDownloader.prototype.isInstalled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var packagename;
            return __generator(this, function (_a) {
                packagename = this.opt.packagename;
                return [2 /*return*/, new Promise(function (resolve) {
                        var _a;
                        if (packagename === AppPackage.KB) {
                            return resolve(true);
                        }
                        window.checkCanOpenNativeUrlCallBack = function (flag) {
                            resolve(flag === 1);
                        };
                        if ((_a = window === null || window === void 0 ? void 0 : window.TencentReading) === null || _a === void 0 ? void 0 : _a.checkCanOpenNativeUrl) {
                            window.TencentReading.checkCanOpenNativeUrl(packagename, 'checkCanOpenNativeUrlCallBack', null);
                        }
                        else {
                            resolve(false);
                        }
                    })];
            });
        });
    };
    /**
     * 下载相关状态信息
     *   Download.UNKNOWN = -1; // 任务默认状态, 复用现有状态
     *   Download.DOWNLOAD_READY = 0; // 下载任务创建完成, 复用现有状态, 下载错误回传此状态, 同时需要一个终端的toast来提示下载错误的原因
     *   Download.DOWNLOADING = 1; // 下载中, 复用现有状态
     *   Download.PAUSED = 2; // 暂停, 复用现有状态
     *   Download.WAITING = 3; // 等待中, 复用现有状态
     *   Download.INSTALL_READY = 4; // 下载完成, 复用现有状态
     *   Download.INSTALLED = 5; // 安装完成, 复用现有状态
     *   Download.UNINSTALLED = 6; // 应用卸载, 新增状态
     */
    KBDownloader.prototype.getStatus = function () {
        var _a;
        if ((_a = this.downloadStatusInfo) === null || _a === void 0 ? void 0 : _a.action) {
            if (this.downloadStatusInfo.action === 5) {
                this.emit('install', true);
            }
            if (this.downloadStatusInfo.action === 6) {
                this.emit('install', false);
            }
            var statusInfo = [
                AppDownloadStatus.TASK_STATUS_CREATED,
                AppDownloadStatus.TASK_STATUS_PROGRESS,
                AppDownloadStatus.TASK_STATUS_PROGRESS,
                AppDownloadStatus.TASK_STATUS_PROGRESS,
                AppDownloadStatus.TASK_STATUS_COMPLETED,
            ][this.downloadStatusInfo.action] || AppDownloadStatus.TASK_STATUS_NONE;
            // 以QB和TBS的状态为准
            return statusInfo;
        }
        return AppDownloadStatus.TASK_STATUS_NONE;
    };
    KBDownloader.prototype.getProgress = function () {
        var _a;
        var percent = parseInt(((_a = this.downloadStatusInfo) === null || _a === void 0 ? void 0 : _a.downPercent) || 0);
        return isNaN(percent) ? 0 : percent;
    };
    return KBDownloader;
}(EventEmitter));
export default KBDownloader;
